import { createContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
	const [formData, setFormData] = useState(() => {
		const savedData = localStorage.getItem("formData");
		return savedData ? JSON.parse(savedData) : {};
	});

	const updateFormData = useCallback((newData) => {
		setFormData((prevData) => {
			const updatedData = { ...prevData, ...newData };
			localStorage.setItem("formData", JSON.stringify(updatedData));
			return updatedData;
		});
	}, []);

	return (
		<FormContext.Provider value={{ formData, updateFormData }}>
			{children}
		</FormContext.Provider>
	);
};

FormProvider.propTypes = {
	children: PropTypes.node.isRequired,
};